import { CompanyQuery, CompanyStatus } from "@/generated/graphql_billing";

/**
 * This function checks if a company is forced cancellation status or not.
 * @param company
 */
export const isForcedCancellation = (
  company: CompanyQuery["company"]
): boolean => {
  return (
    company?.status == CompanyStatus.Suspended &&
    company?.canceledPlanContracts.length > 0
  );
};
